import { render, staticRenderFns } from "./LocaleDropdown.vue?vue&type=template&id=2eaaa2ea&scoped=true"
import script from "./LocaleDropdown.vue?vue&type=script&lang=js"
export * from "./LocaleDropdown.vue?vue&type=script&lang=js"
import style0 from "./LocaleDropdown.vue?vue&type=style&index=0&id=2eaaa2ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eaaa2ea",
  null
  
)

export default component.exports